import Viewer from 'viewerjs';

export default class {
  /**
   * 初始化viewer
   */
  initViewer() {
    this.imgBox = document.getElementById(this.thisId);
    this.viewer = new Viewer(this.imgBox, {
      // 加一个className好定位dom然后实现双击
      className: `viewer-container-${this.thisId}`,
      transition: false,
      loading: true,
      toggleOnDblclick: false,
      url: imgTag => {
        return this.urlTransform(imgTag);
      },
      ready: () => {
        this.viewerContainer = document.getElementsByClassName(`viewer-container-${this.thisId}`)[0];
      },
      show: () => {
        // 双击隐藏
        // this.viewerContainer.addEventListener('dblclick', () => {
        //   this.viewer.hide();
        // }, { once: true });
      },
      shown: () => {
        this.showing = true;
      },
      viewed: () => {
      },
      hidden: ()=>{
        this.showing = false;
      }
    });
  }

  /**
   * 销毁viewer
   */
  removeViewer() {
    if (this.viewer) {
      this.viewer.destroy();
    }
  }

  /**
   * 更新viewer
   */
  updateViewer() {
    if (this.viewer) {
      this.viewer.update();
    }
  }

  /**
   * 让独立模式的图片列表刷新，并开启预览
   */
  showStandalone(){
    this.showStandalone = true;
    this.$nextTick(()=>{
      this.viewer.update();
      this.viewer.show();
    })
  }
}
